import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import * as React from 'react';
import { login, api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { toggleModal } from '../../modal/legacy-modal/index.js';
import { EAPIErrorCode } from '../../utils/fetcher.js';
import { prependPrefix } from '../../utils/style.js';
import { ESendCodeMessageType, ESendCodeType } from '../api/captcha.js';
import 'qs';
import { loginViaSMS } from '../api/sms-login.js';
import { LegacyCaptchaArea } from '../components/captcha/legacy-captcha-area/index.js';
import { LegacyPhoneInput } from '../components/phone-input/legacy-phone-input/index.js';
import { ECaptchaType } from '../components/types.js';
import { FEEDBACK_URL, DEFAULT_REGION } from '../utils/constants.js';
import { createFormToastToggler } from '../utils/toast.js';
import { validate } from '../utils/validate.js';
import '@babel/runtime-corejs3/core-js/promise';
import 'lodash-es';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FORM_CLASS = prependPrefix('legacy-verify-login');
var toggleFormToast = createFormToastToggler(FORM_CLASS);
var LegacyVerifyLogin = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyVerifyLogin, _React$Component);

  var _super = _createSuper(LegacyVerifyLogin);

  function LegacyVerifyLogin(props) {
    var _this;

    _classCallCheck(this, LegacyVerifyLogin);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleLoginSubmit", function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          verifyCode = _this$state.verifyCode,
          username = _this$state.username,
          region = _this$state.region;
      var errs = validate({
        verifyCode: verifyCode,
        phone: username
      });

      if (_Object$keys(errs).length) {
        _this.setState({
          errs: errs
        });

        return;
      }

      _this.setState({
        loading: true
      });

      loginViaSMS({
        mobile: username,
        identify_code: verifyCode,
        remember_me: _this.props.rememberMe ? 1 : 0,
        region: region.code
      }).then(function () {
        if (!_this.props.modal) {
          // 不在 Modal 中使用时，跳转到 backUrl 或首页
          window.location.href = login.getBackUrl();
          return;
        } // 在 Modal 中使用时，跳转到 backUrl 或刷新当前页面


        var backUrl = login.getBackUrl('');

        if (!backUrl) {
          window.location.reload();
          return;
        }

        window.location.href = backUrl;
      }).catch(function (err) {
        var _err$response;

        _this.setState({
          loading: false
        });

        if (!(err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.info)) {
          toggleFormToast('登录失败，请重试');
          return;
        }

        var data = err.response; // 判断用户状态

        if (data.code === EAPIErrorCode.PopupModalRequired) {
          toggleModal({
            type: 'message',
            title: '登录失败',
            params: {
              messageText: data.message || (data.info[0] ? data.info[0].message : data.info),
              cancelText: '知道啦'
            }
          });
          return;
        }

        if (data.code === EAPIErrorCode.PromptFeedbackModal) {
          toggleModal({
            type: 'confirm',
            title: '登录失败',
            params: {
              messageText: data.message || data.info,
              cancelText: '我知道了',
              confirmText: '联系客服',
              onConfirm: function onConfirm() {
                return window.open(FEEDBACK_URL, '_blank');
              }
            }
          });
          return;
        }

        var errorInfo = err.response.info[0] || err.response.info;
        var error = {};

        switch (errorInfo.type) {
          case ESendCodeMessageType.ShowToast:
            toggleFormToast(errorInfo.message);
            break;

          case ESendCodeMessageType.ShowUnderAccount:
            error.phone = errorInfo.message;
            break;

          case ESendCodeMessageType.ShowUnderCode:
            error.verifyCode = errorInfo.message;
            break;
        }

        _this.setState({
          errs: error
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUsernameChange", function (e) {
      var username = e.target.value;

      if (!/^\d+$/.test(username) && username !== '') {
        return;
      }

      var errs = _extends({}, _this.state.errs);

      delete errs.phone;

      _this.setState({
        username: username,
        errs: errs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRegionSelect", function (region) {
      var errs = _extends({}, _this.state.errs);

      delete errs.phone;

      _this.setState({
        region: region,
        errs: errs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSendCodeError", function (error) {
      switch (error.type) {
        case ESendCodeMessageType.ShowUnderAccount:
          _this.setState({
            errs: {
              phone: error.message
            }
          });

          break;

        default:
          toggleFormToast(error.message);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateVerifyCode", function (verifyCode) {
      var errs = _extends({}, _this.state.errs);

      if (verifyCode) delete errs.verifyCode;

      _this.setState({
        verifyCode: verifyCode,
        errs: errs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkAccount", function () {
      var errs = validate({
        phone: _this.state.username
      });

      if (_Object$keys(errs).length) {
        _this.setState({
          errs: errs
        });

        return false;
      }

      return true;
    });

    _this.state = {
      verifyCode: '',
      username: '',
      loading: false,
      sending: false,
      errs: {},
      region: DEFAULT_REGION,
      countdown: 0
    };
    return _this;
  }

  _createClass(LegacyVerifyLogin, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          errs = _this$state2.errs,
          loading = _this$state2.loading,
          username = _this$state2.username,
          region = _this$state2.region;
      var _this$props = this.props,
          disabledCaptcha = _this$props.disabledCaptcha,
          onRememberChange = _this$props.onRememberChange,
          rememberMe = _this$props.rememberMe;
      return /*#__PURE__*/React.createElement("form", {
        className: FORM_CLASS,
        onSubmit: this.handleLoginSubmit
      }, /*#__PURE__*/React.createElement(LegacyPhoneInput, {
        username: username,
        onRegionSelect: this.handleRegionSelect,
        onUsernameChange: this.handleUsernameChange,
        errorMsg: errs.phone
      }), /*#__PURE__*/React.createElement(LegacyCaptchaArea, {
        type: ESendCodeType.SMSLogin,
        captchaType: ECaptchaType.Geetest,
        disabledCaptcha: disabledCaptcha,
        region: region,
        account: username,
        check: this.checkAccount,
        identifyCodeError: errs.verifyCode,
        onInputChange: this.updateVerifyCode,
        onSendCodeError: this.handleSendCodeError
      }), /*#__PURE__*/React.createElement("button", {
        className: classNames('login-btn', {
          loading: loading
        })
      }, !loading && '登录'), /*#__PURE__*/React.createElement("div", {
        className: "bottom-row"
      }, /*#__PURE__*/React.createElement("span", {
        className: "remember-me"
      }, /*#__PURE__*/React.createElement("input", {
        id: "remember-me-checkbox",
        type: "checkbox",
        checked: rememberMe,
        onChange: onRememberChange
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "remember-me-checkbox"
      }, "\u8BB0\u4F4F\u6211")), /*#__PURE__*/React.createElement("a", {
        className: "register-btn",
        href: "".concat(api.MISSEVAN_SITE_MAIN, "/member/regist")
      }, "\u6CE8\u518C")));
    }
  }]);

  return LegacyVerifyLogin;
}(React.Component);

export { LegacyVerifyLogin };
